import { t } from "i18next";
import { useEffect } from "react";
import { Label, Input, InputProps } from "reactstrap";

import { GenerateSequenceNumberRequest } from "../../interfaces";
import { useGenerateSequenceNumberMutation } from "../../store/api/appSettingsApi";
import { SequenceEnum } from "../../enums";

type TProps = InputProps &
  React.InputHTMLAttributes<HTMLInputElement> & {
    request: GenerateSequenceNumberRequest;
    onGenerateSequenceNumber: (sequenceNumber: number) => void;
    mode: "edit" | "add";
  };
export const SequenceNumberInput: React.FC<TProps> = (props) => {
  const [
    generateSequenceNumber,
    { data: seqData, isLoading: seqLoading, isSuccess: seqSuccess },
  ] = useGenerateSequenceNumberMutation();

  useEffect(() => {
    if (props.mode !== "add") return;
    if (
      props.request.type == SequenceEnum.CATEGORY &&
      !props.request.otherType
    ) {
      return;
    }
    if (
      props.request.type == SequenceEnum.CURRICULUM &&
      !props.request.educationSystemId
    ) {
      return;
    }
    if (
      props.request.type == SequenceEnum.EDUCATIONAL_STAGE &&
      (!props.request.curriculumId || !props.request.courseId)
    ) {
      return;
    }
    if (
      props.request.type == SequenceEnum.GRADE &&
      !props.request.educationalStageId &&
      !props.request.courseId
    ) {
      return;
    }
    if (
      (props.request.type == SequenceEnum.SUBJECT ||
        props.request.type == SequenceEnum.PLAN) &&
      (!props.request.courseId || !props.request.gradeId)
    ) {
      return;
    }
    generateSequenceNumber(props.request);
  }, [
    props.mode,
    props.sequenceType,
    props.request.type,
    props.request.otherType,
    props.request.educationSystemId,
    props.request.curriculumId,
    props.request.courseId,
    props.request.gradeId,
    props.request.educationalStageId,
    props.request.subjectId,
  ]);

  useEffect(() => {
    if (!seqLoading && seqSuccess && props.mode === "add") {
      if (seqData) {
        const { sequenceNumber } = seqData;
        props.onGenerateSequenceNumber(sequenceNumber);
      }
    }
  }, [seqLoading, seqSuccess, seqData, props.mode]);

  return (
    <div className="mb-3">
      <Label htmlFor="sequenceNumber" className="form-label">
        {t("sequenceNumber")}
        <span className="text-danger">*</span>
      </Label>
      <Input
        {...props}
        type="text"
        className="form-control"
        id="sequenceNumber"
        name="sequenceNumber"
        placeholder={`${t("enterSequenceNumber")}`}
        minLength={1}
        maxLength={5}
        autoComplete="off"
      />
    </div>
  );
};
